/* jshint esversion: 6 */
/* jshint ignore:start */
import React, { useContext, useEffect, useRef, useState } from "react";
import Dott from "../Icon/more-vertical.svg";
import HidePassword from "../Icon/eye-slash.svg";
import flag from "../Icon/flag-triangle.svg";
import plus from "../Icon/plus.svg";
import Bell from "../Icon/bell-slash.svg";
import BlockIcon from '../Icon/block.gif';
import Setting from "../Icon/settings.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { RxCross2 } from "react-icons/rx";
import { FaStar } from "react-icons/fa";
import axios from "axios";
import { MyContext } from "../Context/MyProvider";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import UserChat from "./UserChat";
import PageHeader from "./PageHeader";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { FiUser, FiArrowLeft, FiMaximize2 } from "react-icons/fi";
import { showTost } from "../showTost";
import verify from "../images/icons/verify.png";
import verify1 from "../images/icons/verify-1.png";
import Review from "../images/icons/information.png";
import LodingLottie from "../Lodinglottie";
import GiftModal from "./GiftModal";
import EngagementModal from "./EngagementModal";
import { emitProfileAction } from "../socket";
import { fetchProfileCompletion, getChatBlockMessage } from "../utils/profileCompletion";
import { ReportComment } from "../utils/reportConstants";
export { ReportComment };

const Detail = () => {
  const location = useLocation();
  const UserProfileId = location.state?.ProfileId || sessionStorage.getItem("DetailsId");
  const { t } = useTranslation();

  const { basUrl, imageBaseURL, setChatUserName, setChatId, chatId, isSuperLikeMasterEnabled } = useContext(MyContext);

  const [options, setOption] = useState(false);
  const [report, setReport] = useState(false);
  const [dot, setDot] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  const [isEngagementOpen, setIsEngagementOpen] = useState(false);
  const [engagementInitialType, setEngagementInitialType] = useState("SUPER_LIKE");
  const [api, setApi] = useState([]);
  const [imageData, setImageData] = useState([]);
  const [isverify, setIsVerify] = useState();
  const [comment, setComment] = useState();
  const [userCoords, setUserCoords] = useState({ lat: null, long: null });
  const [loading, setLoading] = useState(true);
  const [iconDis, setIconDis] = useState([]);
  const [planAccess, setPlanAccess] = useState({
    directChat: "0",
    chat: "0",
    gifts: "0",
    planId: "0",
  });
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewIndex, setPreviewIndex] = useState(0);

  const handleOpenPreview = (index) => {
    setPreviewIndex(index);
    setPreviewOpen(true);
  };

  const handlePrevImage = (e) => {
    e?.stopPropagation();
    if (imageData?.length > 0) {
      setPreviewIndex((prev) => (prev - 1 + imageData.length) % imageData.length);
    }
  };

  const handleNextImage = (e) => {
    e?.stopPropagation();
    if (imageData?.length > 0) {
      setPreviewIndex((prev) => (prev + 1) % imageData.length);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!previewOpen) return;
      if (e.key === "Escape") setPreviewOpen(false);
      if (e.key === "ArrowLeft") handlePrevImage();
      if (e.key === "ArrowRight") handleNextImage();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [previewOpen, imageData]);

  const navigate = useNavigate();
  const fetchedRef = useRef(false);
  const detailSource = location.state?.sourceTab || sessionStorage.getItem("ExploreDetailSource") || sessionStorage.getItem("Explore") || "";
  const isSourceDiscover = detailSource === "Discover";
  const isSourceFavorite = detailSource === "Favorite";
  const isSourceMatch = detailSource === "Match";
  const isSourceLike = detailSource === "Like";
  const isSourcePassed = detailSource === "Passed";
  const isMatchedProfile = api?.is_matched === "1";
  const hasDirectChatPlan = String(planAccess.directChat) === "1";
  const canRespondToProfile = !isMatchedProfile && !isSourceFavorite;
  const canChatProfile = isMatchedProfile || isSourceMatch || hasDirectChatPlan;
  const canGiftProfile = canChatProfile && String(planAccess.gifts) === "1";
  const canSendSuperLike = isSourceDiscover && !isMatchedProfile;
  const canPassProfile = canRespondToProfile && !iconDis?.includes("1");
  const canLikeProfile = canRespondToProfile && !iconDis?.includes("2");
  const hasDetailActions = canPassProfile || canChatProfile || canSendSuperLike || canLikeProfile || canGiftProfile;

  const getUserId = () => {
    try {
      return JSON.parse(localStorage.getItem("Register_User") || "{}").id;
    } catch {
      return null;
    }
  };

  const toggleBottomSheet = (e) => {
    setIsVisible(e?.target?.id !== 'BlockSection');
  };

  const ReportToggle = (e) => {
    setReport(e !== 'ReportSection');
  };

  const SendReportHamdler = (id) => {
    const uid = getUserId();
    if (dot && uid) {
      axios.post(`${basUrl}report`, { uid, reporter_id: id, comment })
        .then((res) => {
          if (res.data.Result === "true") {
            showTost({ title: res.data.ResponseMsg });
            setReport(false);
          }
        });
    } else {
      showTost({ title: "Something Went Wrong!" });
    }
  };

  const BlockHandler = () => {
    const uid = getUserId();
    if (uid) {
      axios.post(`${basUrl}profile_block`, { uid, profile_id: api.profile_id })
        .then((res) => {
          const Id = sessionStorage.getItem("Icon-Color");
          navigate(Id === "Explore" ? "/explore" : "/");
          showTost({ title: res.data.ResponseMsg });
          setIsVisible(false);
        });
    }
  };

  const FavouriteHandler = async () => {
    const uid = getUserId();
    if (!uid) return;
    try {
      const response = await axios.post(`${basUrl}favourite`, {
        uid,
        profile_id: api.profile_id
      });
      if (response.data.Result === "true") {
        showTost({ title: response.data.ResponseMsg });
        setApi(prev => ({
          ...prev,
          is_favourite: prev.is_favourite === "1" ? "0" : "1"
        }));
        setOption(false);
      } else {
        showTost({ title: response.data.ResponseMsg });
      }
    } catch (error) {
      console.error("Error toggling favorite status:", error);
    }
  };

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setUserCoords({ lat: String(pos.coords.latitude), long: String(pos.coords.longitude) });
      },
      () => {
        const uLat = localStorage.getItem("user_latitude");
        const uLong = localStorage.getItem("user_longitude");
        if (uLat && uLong) setUserCoords({ lat: uLat, long: uLong });
      }
    );
  }, []);

  useEffect(() => {
    const uid = getUserId();
    if (!UserProfileId || !uid) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const profilePayload = {
          uid,
          profile_id: UserProfileId,
          lats: userCoords.lat,
          longs: userCoords.long,
        };
        const homePayload = {
          uid,
          lats: userCoords.lat,
          longs: userCoords.long,
        };

        const [response, homeResponse] = await Promise.all([
          axios.post(`${basUrl}profile_info`, profilePayload),
          axios.post(`${basUrl}home_data`, homePayload).catch(() => null),
        ]);

        if (response.data.Result === "true") {
          setApi(response.data.profileinfo);
          setImageData(response.data.profileinfo?.profile_images || []);
          setIsVerify(response.data.profileinfo?.is_verify);
        }
        const accessSource = homeResponse?.data?.Result === "true" ? homeResponse.data : response.data;
        if (accessSource?.Result === "true") {
          setPlanAccess({
            directChat: accessSource.direct_chat || "0",
            chat: accessSource.chat || "0",
            gifts: accessSource.entitlements?.gifts?.allowed ? "1" : "0",
            planId: accessSource.plan_id || "0",
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [basUrl, UserProfileId, userCoords]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000
  };

  const NavigateHandler = () => {
    const Id = sessionStorage.getItem("Icon-Color");
    navigate(Id === "Explore" ? "/explore" : "/");
    sessionStorage.removeItem("DetailsId");
  };

  const handleLikeAction = (id, action) => {
    const uid = getUserId();
    if (id && uid) {
      const fallback = (payload = {}) => axios.post(`${basUrl}like_dislike`, {
        uid,
        profile_id: id,
        action,
        client_action_id: payload.client_action_id,
      });
      emitProfileAction({ profileId: id, action, fallback })
        .then((res) => {
          const data = res?.data || {};
          if (!data.Result || data.Result === "true") {
            showTost({ title: data.ResponseMsg || "Action Recorded!" });
          }
          if (action === "LIKE") {
            navigate(sessionStorage.getItem("Icon-Color") === "Home" ? "/" : "/explore");
          } else {
            NavigateHandler();
          }
        })
        .catch((error) => {
          showTost({ title: error.message || "Action failed!" });
        });
    }
  };

  const ProfileLikeHandler = (id) => handleLikeAction(id, "LIKE");
  const ProfileUnLikeHandler = (id) => handleLikeAction(id, "UNLIKE");

  const ProfileSuperLikeHandler = async (id) => {
    const uid = getUserId();
    if (!id || !uid) return;

    try {
      const token = localStorage.getItem("token") || "";
      const headers = { authorization: token ? `Bearer ${token}` : "" };
      const cleanBaseUrl = (basUrl || "").trim().replace(/\/+$/, "");
      const base = cleanBaseUrl.toLowerCase().endsWith("/api")
        ? cleanBaseUrl.slice(0, -4)
        : cleanBaseUrl;
      const res = await axios.post(
        `${base}/api/use_super_like`,
        { uid, target_uid: id },
        { headers }
      );

      if (res.data.Result === "true") {
        showTost({ title: res.data.ResponseMsg || "Super Like sent!" });
        NavigateHandler();
      } else {
        showTost({ title: res.data.ResponseMsg || "No Super Likes left! Recharge now." });
        setEngagementInitialType("SUPER_LIKE");
        setIsEngagementOpen(true);
      }
    } catch (error) {
      setEngagementInitialType("SUPER_LIKE");
      setIsEngagementOpen(true);
    }
  };

  const ChatHandler = async (UserId, name) => {
    if (!canChatProfile) {
      showTost({ title: "Direct Chat is not enabled in your plan" });
      navigate("/upgrade");
      return;
    }
    const uid = getUserId();
    const completion = await fetchProfileCompletion(basUrl, uid);
    const chatBlockMessage = getChatBlockMessage(completion);
    if (chatBlockMessage) {
      showTost({ title: chatBlockMessage });
      navigate("/profile", {
        state: {
          profileCompletionRequired: true,
          missingTasks: completion?.missing_tasks || [],
        },
      });
      return;
    }
    if (setChatId) setChatId(UserId);
    if (setChatUserName) setChatUserName(name);
    sessionStorage.setItem("DetailsId", UserId);
    navigate("/chat", { state: { ProfileId: UserId, name: name } });
  };

  return (
    <div className="main-wrapper bg-[#e5e5e5] dashboard outline-none">
      {!loading ? (
        <div
          onClick={() => options && setOption(!options)}
          className="content-body relative"
        >
          <div className="container-fluid my-2 sm:my-4 px-2.5 sm:px-4">
            <PageHeader
              title={t("Profile Details")}
              subtitle={t("View complete profile information, photos, and interests")}
              breadcrumbs={[
                { label: t("Explore"), path: "/explore" },
                { label: api?.profile_name || t("Details") }
              ]}
              icon={FiUser}
              actions={
                <button
                  onClick={NavigateHandler}
                  className="flex items-center gap-2 bg-purple-50 hover:bg-purple-100 text-purple-700 font-semibold px-4 py-2 rounded-xl transition-all border border-purple-100 cursor-pointer shadow-xs"
                >
                  <FiArrowLeft className="text-base" />
                  <span>{t("Back")}</span>
                </button>
              }
            />
            <div className="bg-white p-4 sm:p-6 rounded-2xl border border-gray-200/80 shadow-xs">
              <div>
                <div className="row items-start g-4">
                  <div className="col-xxl-5">
                    <div className="user-images-slider">
                      <div className="swiper-container images-slider overflow-hidden relative">
                        <button className="absolute p-3 hidden max-_430_:block right-[5px] z-[555]" onClick={() => setOption(!options)}>
                          <svg width="6" height="20" viewBox="0 0 4 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path className="fill-white" d="M2.02002 3.5C1.19102 3.5 0.515015 2.829 0.515015 2C0.515015 1.171 1.18201 0.5 2.01001 0.5H2.02002C2.84902 0.5 3.52002 1.171 3.52002 2C3.52002 2.829 2.84902 3.5 2.02002 3.5ZM3.52002 10C3.52002 9.171 2.84902 8.5 2.02002 8.5H2.01001C1.18201 8.5 0.515015 9.171 0.515015 10C0.515015 10.829 1.19102 11.5 2.02002 11.5C2.84902 11.5 3.52002 10.829 3.52002 10ZM3.52002 18C3.52002 17.171 2.84902 16.5 2.02002 16.5H2.01001C1.18201 16.5 0.515015 17.171 0.515015 18C0.515015 18.829 1.19102 19.5 2.02002 19.5C2.84902 19.5 3.52002 18.829 3.52002 18Z" fill="#25314C" />
                          </svg>
                        </button>
                        {options && (
                          <div className="bg-white m-0 px-[5px] py-[5px] hidden max-_430_:block rounded-[5px] absolute top-[45px] right-[18px] z-[888]">
                            <button onClick={toggleBottomSheet} className="py-[5px] px-[10px] flex items-center gap-[10px] font-[600]">
                              <img src={HidePassword} style={{ height: "100%" }} alt="" /> {t('Block')}
                            </button>
                            <div className="border-[1px] border-gray-300"></div>
                            <button onClick={ReportToggle} className="py-[5px] px-[10px] flex items-center gap-[10px] font-[600]">
                              <img src={flag} alt="" style={{ height: "100%" }} />
                              {t('Report')}
                            </button>
                            <div className="border-[1px] border-gray-300"></div>
                            <button onClick={FavouriteHandler} className="py-[5px] px-[10px] flex items-center gap-[10px] font-[600]">
                              <svg width="18" height="18" viewBox="0 0 24 24" fill={api?.is_favourite === "1" ? "#FFC107" : "none"} stroke="#6b7280" strokeWidth="2">
                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                              </svg>
                              {api?.is_favourite === "1" ? t('Unfavourite') : t('Favourite')}
                            </button>
                          </div>
                        )}
                        {imageData?.length > 1
                          ? <Slider {...settings}>
                            {
                              imageData.map((el, index) => {
                                  return <div key={index} className="cursor-pointer group relative overflow-hidden rounded-[1rem]" onClick={() => handleOpenPreview(index)}>
                                    <img className="rounded-[1rem] relative w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.02]" src={`${imageBaseURL}${el}`} alt="" />
                                    <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity rounded-[1rem] flex items-center justify-center pointer-events-none">
                                      <span className="bg-black/60 text-white p-2.5 rounded-full shadow-lg backdrop-blur-sm">
                                        <FiMaximize2 className="text-xl" />
                                      </span>
                                    </div>
                                  </div>
                              })
                            }
                          </Slider>
                          : imageData?.map((el, idx) => {
                              return <div key={idx} className="cursor-pointer group relative overflow-hidden rounded-[1rem]" onClick={() => handleOpenPreview(idx)}>
                                <img className="rounded-[1rem] w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.02]" src={`${imageBaseURL}${el}`} alt="" />
                                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity rounded-[1rem] flex items-center justify-center pointer-events-none">
                                  <span className="bg-black/60 text-white p-2.5 rounded-full shadow-lg backdrop-blur-sm">
                                    <FiMaximize2 className="text-xl" />
                                  </span>
                                </div>
                              </div>
                          })
                        }
                        {hasDetailActions && <div className="absolute bottom-10 max-_1445_:bottom-16 max-_430_:hidden flex items-center justify-center w-[100%] gap-[10px]">
                          <div className=" flex items-center gap-[10px] px-[8px] py-[6px] rounded-[50px] bg-black">
                            {canPassProfile ? <button onClick={() => ProfileUnLikeHandler(api.profile_id)} className="action-btn avatar avatar-lg rounded-full z-1 bg-white" title={isSourceLike ? t("Pass") : t("Pass")} >
                              <RxCross2 className="w-[50px] text-black" />
                            </button> : ""}
                            {canChatProfile && <button onClick={() => ChatHandler(api.profile_id, api.profile_name)} className="action-btn avatar avatar-lg rounded-full z-1 bg-white" title={t("Chat")}>
                              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M3.33398 20.0247C3.33398 11.2449 10.3507 3.33301 20.034 3.33301C29.5007 3.33301 36.6673 11.0947 36.6673 19.9746C36.6673 30.2734 28.2673 36.6663 20.0007 36.6663C17.2673 36.6663 14.234 35.9319 11.8007 34.4964C10.9507 33.979 10.234 33.5951 9.31732 33.8955L5.95065 34.897C5.10065 35.1641 4.33398 34.4964 4.58398 33.5951L5.70065 29.8561C5.88398 29.3387 5.85065 28.7879 5.58398 28.3539C4.15065 25.7166 3.33398 22.8289 3.33398 20.0247ZM17.834 20.0247C17.834 21.2098 18.784 22.1612 19.9673 22.1779C21.1507 22.1779 22.1007 21.2098 22.1007 20.0414C22.1007 18.8563 21.1507 17.9049 19.9673 17.9049C18.8007 17.8882 17.834 18.8563 17.834 20.0247ZM25.5173 20.0414C25.5173 21.2098 26.4673 22.1779 27.6507 22.1779C28.834 22.1779 29.784 21.2098 29.784 20.0414C29.784 18.8563 28.834 17.9049 27.6507 17.9049C26.4673 17.9049 25.5173 18.8563 25.5173 20.0414ZM12.284 22.1779C11.1173 22.1779 10.1507 21.2098 10.1507 20.0414C10.1507 18.8563 11.1007 17.9049 12.284 17.9049C13.4673 17.9049 14.4173 18.8563 14.4173 20.0414C14.4173 21.2098 13.4673 22.1612 12.284 22.1779Z" fill="#000000" />
                              </svg>
                            </button>}
                            {canSendSuperLike && isSuperLikeMasterEnabled && <button onClick={() => ProfileSuperLikeHandler(api.profile_id)} className="action-btn avatar avatar-lg rounded-full z-1 bg-amber-500 hover:bg-amber-600 text-white flex items-center justify-center shadow-lg transition-transform hover:scale-110 border-none cursor-pointer" title={t("Super Like")}>
                              <FaStar className="text-white text-xl" />
                            </button>}
                            {canLikeProfile ? <button onClick={() => ProfileLikeHandler(api.profile_id)} className="action-btn avatar avatar-lg rounded-full z-1 bg-red-500" title={isSourceLike ? t("Like Back") : isSourcePassed ? t("Undo Pass") : t("Like")}>
                              <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M26.4154 4.7698C27.4671 4.7698 28.5171 4.91813 29.5154 5.25313C35.6671 7.25313 37.8837 14.0031 36.0321 19.9031C34.9821 22.9181 33.2654 25.6698 31.0171 27.9181C27.7987 31.0348 24.2671 33.8015 20.4654 36.1848L20.0487 36.4365L19.6154 36.1681C15.8004 33.8015 12.2487 31.0348 9.00039 27.9015C6.76706 25.6531 5.04873 22.9181 3.98206 19.9031C2.09873 14.0031 4.31539 7.25313 10.5337 5.21813C11.0171 5.05146 11.5154 4.9348 12.0154 4.8698H12.2154C12.6837 4.80146 13.1487 4.7698 13.6154 4.7698H13.7987C14.8487 4.80146 15.8654 4.9848 16.8504 5.3198H16.9487C17.0154 5.35146 17.0654 5.38646 17.0987 5.41813C17.4671 5.53646 17.8154 5.6698 18.1487 5.85313L18.7821 6.13646C18.9351 6.21808 19.1069 6.3428 19.2553 6.45058C19.3494 6.51887 19.4341 6.58037 19.4987 6.6198C19.5259 6.63585 19.5536 6.65198 19.5814 6.66825C19.7243 6.75167 19.8732 6.83857 19.9987 6.9348C21.8504 5.5198 24.0987 4.75313 26.4154 4.7698ZM30.8487 16.7698C31.5321 16.7515 32.1154 16.2031 32.1654 15.5015V15.3031C32.2154 12.9681 30.8004 10.8531 28.6487 10.0365C27.9654 9.80146 27.2154 10.1698 26.9654 10.8698C26.7321 11.5698 27.0987 12.3365 27.7987 12.5848C28.8671 12.9848 29.5821 14.0365 29.5821 15.2015V15.2531C29.5504 15.6348 29.6654 16.0031 29.8987 16.2865C30.1321 16.5698 30.4821 16.7348 30.8487 16.7698Z" fill="#FFFFFF" />
                                <defs>
                                  <linearGradient id="paint0_linear_1606_27736" x1="36.6657" y1="36.4365" x2="-2.66883" y2="24.4315" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#FF0025" />
                                    <stop offset="1" stopColor="#FF6B81" />
                                  </linearGradient>
                                </defs>
                              </svg>
                            </button> : ""}
                            {canGiftProfile && <button className="action-btn avatar avatar-lg rounded-full z-1 bg-white" onClick={(e) => { e.stopPropagation(); setIsVisible2(true); }} title={t("Gift")} >
                              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.16675 22.4997H18.75V34.4997C18.75 34.7764 18.5266 34.9997 18.2499 34.9997H11.6667C8.33333 34.9997 6.66667 33.333 6.66667 29.9997V22.9997C6.66667 22.723 6.89008 22.4997 7.16675 22.4997ZM32.8333 22.4997H21.25V34.4997C21.25 34.7764 21.4734 34.9997 21.7501 34.9997H28.3333C31.6667 34.9997 33.3333 33.333 33.3333 29.9997V22.9997C33.3333 22.723 33.1099 22.4997 32.8333 22.4997ZM35 14.1664V19.4997C35 19.7764 34.7766 19.9997 34.4999 19.9997H21.25V14.1664H18.75V19.9997H5.50008C5.22341 19.9997 5 19.7764 5 19.4997V14.1664C5 12.7864 6.12 11.6664 7.5 11.6664H9.2749C8.74324 10.6364 8.54502 9.40801 9.01835 8.07301C9.49002 6.74301 10.5666 5.64139 11.9132 5.21972C13.7766 4.63639 15.6933 5.24634 16.8667 6.67134C16.92 6.73634 18.795 9.23132 20.0016 10.8346C21.2066 9.23132 23.08 6.74133 23.125 6.68467C24.3067 5.248 26.2066 4.64298 28.065 5.20965C29.365 5.60798 30.4216 6.63803 30.9216 7.90303C31.475 9.30303 31.2817 10.5914 30.7284 11.6647H32.5033C33.8799 11.6664 35 12.7864 35 14.1664ZM17.4967 11.6664C16.3684 10.1664 15.005 8.35299 14.9133 8.23465C14.5317 7.76965 13.9633 7.49969 13.3333 7.49969C12.185 7.49969 11.25 8.43469 11.25 9.58302C11.25 10.7314 12.185 11.6664 13.3333 11.6664H17.4967ZM28.75 9.58302C28.75 8.43469 27.815 7.49969 26.6667 7.49969C26.0367 7.49969 25.4682 7.76964 25.0649 8.2613C24.9866 8.36464 23.6283 10.1697 22.5033 11.6664H26.6667C27.815 11.6664 28.75 10.7314 28.75 9.58302Z" fill="#000000" />
                              </svg>
                            </button>}
                          </div>
                        </div>}

                        {hasDetailActions && <div className="hidden max-_430_:block z-[777] relative">
                          <div className="fixed bottom-5 left-0 flex items-center justify-center w-[99%] gap-[10px]">
                            <div className="flex gap-[1rem] rounded-full px-[5px] items-center bg-black py-[5px]">
                              {canPassProfile ? <button onClick={() => ProfileUnLikeHandler(api.profile_id)} className="action-btn avatar avatar-lg rounded-full z-1 bg-white" title={t("Pass")} >
                                <RxCross2 className="w-[50px] text-black" />
                              </button> : ""}
                              {canChatProfile && <button onClick={() => ChatHandler(api.profile_id, api.profile_name)} className="action-btn avatar avatar-lg rounded-full z-1 bg-white" title={t("Chat")}>
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path fillRule="evenodd" clipRule="evenodd" d="M3.33398 20.0247C3.33398 11.2449 10.3507 3.33301 20.034 3.33301C29.5007 3.33301 36.6673 11.0947 36.6673 19.9746C36.6673 30.2734 28.2673 36.6663 20.0007 36.6663C17.2673 36.6663 14.234 35.9319 11.8007 34.4964C10.9507 33.979 10.234 33.5951 9.31732 33.8955L5.95065 34.897C5.10065 35.1641 4.33398 34.4964 4.58398 33.5951L5.70065 29.8561C5.88398 29.3387 5.85065 28.7879 5.58398 28.3539C4.15065 25.7166 3.33398 22.8289 3.33398 20.0247ZM17.834 20.0247C17.834 21.2098 18.784 22.1612 19.9673 22.1779C21.1507 22.1779 22.1007 21.2098 22.1007 20.0414C22.1007 18.8563 21.1507 17.9049 19.9673 17.9049C18.8007 17.8882 17.834 18.8563 17.834 20.0247ZM25.5173 20.0414C25.5173 21.2098 26.4673 22.1779 27.6507 22.1779C28.834 22.1779 29.784 21.2098 29.784 20.0414C29.784 18.8563 28.834 17.9049 27.6507 17.9049C26.4673 17.9049 25.5173 18.8563 25.5173 20.0414ZM12.284 22.1779C11.1173 22.1779 10.1507 21.2098 10.1507 20.0414C10.1507 18.8563 11.1007 17.9049 12.284 17.9049C13.4673 17.9049 14.4173 18.8563 14.4173 20.0414C14.4173 21.2098 13.4673 22.1612 12.284 22.1779Z" fill="#000000" />
                                </svg>
                              </button>}
                              {canSendSuperLike && isSuperLikeMasterEnabled && <button onClick={() => ProfileSuperLikeHandler(api.profile_id)} className="action-btn avatar avatar-lg rounded-full z-1 bg-amber-500 hover:bg-amber-600 text-white flex items-center justify-center shadow-lg transition-transform hover:scale-110 border-none cursor-pointer" title={t("Super Like")}>
                                <FaStar className="text-white text-xl" />
                              </button>}
                              {canLikeProfile ? <button onClick={() => ProfileLikeHandler(api.profile_id)} className="action-btn avatar avatar-lg rounded-full z-1 bg-red-500" title={isSourceLike ? t("Like Back") : isSourcePassed ? t("Undo Pass") : t("Like")}>
                                <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path fillRule="evenodd" clipRule="evenodd" d="M26.4154 4.7698C27.4671 4.7698 28.5171 4.91813 29.5154 5.25313C35.6671 7.25313 37.8837 14.0031 36.0321 19.9031C34.9821 22.9181 33.2654 25.6698 31.0171 27.9181C27.7987 31.0348 24.2671 33.8015 20.4654 36.1848L20.0487 36.4365L19.6154 36.1681C15.8004 33.8015 12.2487 31.0348 9.00039 27.9015C6.76706 25.6531 5.04873 22.9181 3.98206 19.9031C2.09873 14.0031 4.31539 7.25313 10.5337 5.21813C11.0171 5.05146 11.5154 4.9348 12.0154 4.8698H12.2154C12.6837 4.80146 13.1487 4.7698 13.6154 4.7698H13.7987C14.8487 4.80146 15.8654 4.9848 16.8504 5.3198H16.9487C17.0154 5.35146 17.0654 5.38646 17.0987 5.41813C17.4671 5.53646 17.8154 5.6698 18.1487 5.85313L18.7821 6.13646C18.9351 6.21808 19.1069 6.3428 19.2553 6.45058C19.3494 6.51887 19.4341 6.58037 19.4987 6.6198C19.5259 6.63585 19.5536 6.65198 19.5814 6.66825C19.7243 6.75167 19.8732 6.83857 19.9987 6.9348C21.8504 5.5198 24.0987 4.75313 26.4154 4.7698ZM30.8487 16.7698C31.5321 16.7515 32.1154 16.2031 32.1654 15.5015V15.3031C32.2154 12.9681 30.8004 10.8531 28.6487 10.0365C27.9654 9.80146 27.2154 10.1698 26.9654 10.8698C26.7321 11.5698 27.0987 12.3365 27.7987 12.5848C28.8671 12.9848 29.5821 14.0365 29.5821 15.2015V15.2531C29.5504 15.6348 29.6654 16.0031 29.8987 16.2865C30.1321 16.5698 30.4821 16.7348 30.8487 16.7698Z" fill="#FFFFFF" />
                                <defs>
                                  <linearGradient id="paint0_linear_1606_27736" x1="36.6657" y1="36.4365" x2="-2.66883" y2="24.4315" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#FF0025" />
                                    <stop offset="1" stopColor="#FF6B81" />
                                  </linearGradient>
                                </defs>
                              </svg>
                            </button> : ""}
                            {canGiftProfile && <button className="action-btn avatar avatar-lg rounded-full z-1 bg-white" onClick={(e) => { e.stopPropagation(); setIsVisible2(true); }} title={t("Gift")} >
                              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.16675 22.4997H18.75V34.4997C18.75 34.7764 18.5266 34.9997 18.2499 34.9997H11.6667C8.33333 34.9997 6.66667 33.333 6.66667 29.9997V22.9997C6.66667 22.723 6.89008 22.4997 7.16675 22.4997ZM32.8333 22.4997H21.25V34.4997C21.25 34.7764 21.4734 34.9997 21.7501 34.9997H28.3333C31.6667 34.9997 33.3333 33.333 33.3333 29.9997V22.9997C33.3333 22.723 33.1099 22.4997 32.8333 22.4997ZM35 14.1664V19.4997C35 19.7764 34.7766 19.9997 34.4999 19.9997H21.25V14.1664H18.75V19.9997H5.50008C5.22341 19.9997 5 19.7764 5 19.4997V14.1664C5 12.7864 6.12 11.6664 7.5 11.6664H9.2749C8.74324 10.6364 8.54502 9.40801 9.01835 8.07301C9.49002 6.74301 10.5666 5.64139 11.9132 5.21972C13.7766 4.63639 15.6933 5.24634 16.8667 6.67134C16.92 6.73634 18.795 9.23132 20.0016 10.8346C21.2066 9.23132 23.08 6.74133 23.125 6.68467C24.3067 5.248 26.2066 4.64298 28.065 5.20965C29.365 5.60798 30.4216 6.63803 30.9216 7.90303C31.475 9.30303 31.2817 10.5914 30.7284 11.6647H32.5033C33.8799 11.6664 35 12.7864 35 14.1664ZM17.4967 11.6664C16.3684 10.1664 15.005 8.35299 14.9133 8.23465C14.5317 7.76965 13.9633 7.49969 13.3333 7.49969C12.185 7.49969 11.25 8.43469 11.25 9.58302C11.25 10.7314 12.185 11.6664 13.3333 11.6664H17.4967ZM28.75 9.58302C28.75 8.43469 27.815 7.49969 26.6667 7.49969C26.0367 7.49969 25.4682 7.76964 25.0649 8.2613C24.9866 8.36464 23.6283 10.1697 22.5033 11.6664H26.6667C27.815 11.6664 28.75 10.7314 28.75 9.58302Z" fill="#000000" />
                              </svg>
                            </button>}
                            </div>
                          </div>
                        </div>}
                      </div>
                    </div>
                  </div><div className="col-xxl-7">
                    <div className="user-profile">
                      <div className="border-bottom d-sm-flex align-items-cneter px-sm-2 py-4 px-1">
                        <div className="d-flex items-center flex-fill gap-[10px]">
                          <h4 className="fw-semi-bold m-0">{api?.profile_name}, {api?.profile_age}</h4>
                          {isverify === "1"
                            ? <div className="tooltip cursor-pointer">
                              <img src={Review} style={{ width: "30px", height: "30px" }} alt="" />
                              <span className="tooltiptext whitespace-nowrap -bottom-[35px] left-[8px]">{t('Under Review')}</span>
                            </div>
                            : isverify === "2"
                              ? <div className="tooltip cursor-pointer">
                                <img src={verify} style={{ width: "30px", height: "30px" }} alt="" />
                                <span className="tooltiptext whitespace-nowrap -bottom-[35px] left-[10px]">{t('Is Verify')}</span>
                              </div>
                              : <div className="tooltip cursor-pointer">
                                <img src={verify1} style={{ width: "30px", height: "30px" }} alt="" />
                                <span className="tooltiptext whitespace-nowrap -bottom-[35px] -left-[10px]">{t('Unverified')}</span>
                              </div>
                          }
                        </div>
                        <div className="flex items-center gap-[5px] max-_580_:mt-[15px] z-[111]">
                          <svg
                            className="svg-gradient"
                            width="15"
                            height="18"
                            viewBox="0 0 15 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path style={{ fill: "rgba(152,14,255,255)" }}
                              d="M12.201 1.72304C11.4404 1.10344 10.5568 0.65271 9.60864 0.400784C8.66052 0.148858 7.66965 0.101496 6.70182 0.261844C5.734 0.422192 4.81135 0.786581 3.99514 1.33082C3.17892 1.87506 2.48782 2.58669 1.9677 3.41849C1.44758 4.25028 1.11034 5.18319 0.978386 6.1553C0.84643 7.1274 0.922767 8.11646 1.20233 9.0568C1.4819 9.99714 1.95829 10.8673 2.59989 11.6094C3.24149 12.3515 4.03361 12.9487 4.92367 13.3612L6.51275 16.5394C6.63596 16.7857 6.82531 16.9928 7.0596 17.1376C7.29388 17.2824 7.56385 17.359 7.83925 17.359C8.11465 17.359 8.38462 17.2824 8.6189 17.1376C8.85318 16.9928 9.04253 16.7857 9.16574 16.5394L10.7674 13.3622C11.8299 12.8664 12.7489 12.1086 13.4381 11.1601C14.1274 10.2115 14.5642 9.10335 14.7075 7.93965C14.8509 6.77594 14.696 5.59489 14.2576 4.50746C13.8191 3.42002 13.1115 2.46188 12.201 1.72304ZM7.83925 10.0614C7.25267 10.0614 6.67927 9.88746 6.19155 9.56157C5.70383 9.23569 5.3237 8.7725 5.09923 8.23057C4.87475 7.68865 4.81602 7.09233 4.93046 6.51703C5.04489 5.94172 5.32735 5.41327 5.74213 4.9985C6.1569 4.58373 6.68535 4.30126 7.26065 4.18683C7.83596 4.07239 8.43228 4.13113 8.9742 4.3556C9.51613 4.58007 9.97932 4.9602 10.3052 5.44792C10.6311 5.93564 10.805 6.50904 10.805 7.09562C10.805 7.88219 10.4925 8.63653 9.93635 9.19272C9.38016 9.74891 8.62582 10.0614 7.83925 10.0614Z"
                            ></path>
                          </svg>
                          <div className="flex items-center gap-[10px] relative">
                            <span className="fs-16 text-gray">{api?.profile_distance} {t("from you")}</span>
                            <button onClick={() => setOption(!options)}>
                              <img
                                src={Dott}
                                className="w-[20px] h-[20px] max-_430_:hidden"
                                alt=""
                              />
                            </button>
                            {options && (
                              <div className="bg-white border border-gray-100 shadow-lg m-0 px-[5px] py-[5px] max-_430_:hidden rounded-[5px] absolute top-[35px] right-[10px] z-[999] min-w-[140px]">
                                <button onClick={toggleBottomSheet} className="py-[5px] px-[10px] flex items-center gap-[10px] font-[600] w-full hover:bg-gray-50 rounded">
                                  <img src={HidePassword} alt="" /> {t("Block")}
                                </button>
                                <div className="border-[1px] border-gray-200 my-1"></div>
                                <button onClick={ReportToggle} className="py-[5px] px-[10px] flex items-center gap-[10px] font-[600] w-full hover:bg-gray-50 rounded">
                                  <img src={flag} alt="" />
                                  {t("Report")}
                                </button>
                                <div className="border-[1px] border-gray-200 my-1"></div>
                                <button onClick={FavouriteHandler} className="py-[5px] px-[10px] flex items-center gap-[10px] font-[600] w-full hover:bg-gray-50 rounded">
                                  <svg width="18" height="18" viewBox="0 0 24 24" fill={api?.is_favourite === "1" ? "#FFC107" : "none"} stroke="#6b7280" strokeWidth="2">
                                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                                  </svg>
                                  {api?.is_favourite === "1" ? t('Unfavourite') : t('Favourite')}
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {api?.profile_bio === "undefined" || api?.profile_bio === "" ? "" : <div className="px-sm-2 py-4 px-1 border-bottom">
                        <h6 className="fw-semi-bold mb-2">{t("Bio")} : <span className="fs-15 font-[400]">{api?.profile_bio}</span></h6>
                      </div>}
                      <div className="border-bottom px-sm-2 py-4 px-1 user-interests">
                        <h6 className="fw-semi-bold mb-2">{t('Interests')}:</h6>
                        <div className="d-flex flex-wrap list-group-items round-style">
                          {api?.interest_list?.map((item, index) => {
                            return <div key={index} className="list-item d-flex align-items-center justify-content-center py-2 px-3 fw-medium">
                              <span>{item?.title}</span>
                              <img
                                src={imageBaseURL + item?.img}
                                alt="english"
                                className="rounded-circle lang-tag-icon"
                              />
                            </div>
                          })}
                        </div>
                      </div>
                      <div className="border-bottom px-sm-2 py-4 px-1">
                        <h6 className="fw-semi-bold mb-2">{t("Languages")}:</h6>
                        <div className="d-flex flex-wrap list-group-items round-style">
                          {
                            api?.language_list?.map((item, index) => {
                              return <div key={index} className="list-item d-flex align-items-center justify-content-center py-2 px-3 fw-medium">
                                <img
                                  src={imageBaseURL + item?.img}
                                  alt="english"
                                  className="rounded-circle lang-tag-icon"
                                />
                                <span>{item?.title}</span>
                              </div>
                            })
                          }

                        </div>
                      </div>
                      <div className="border-bottom px-sm-2 py-4 px-1">
                        <h6 className="fw-semi-bold mb-2">{t("Relationship Goals")}:</h6>
                        <div className="d-flex flex-wrap list-group-items round-style">
                          <div className="list-item d-flex align-items-center justify-content-center py-2 px-3 fw-medium">
                            {api?.relation_title}
                          </div>
                        </div>
                      </div>
                      <div className=" px-sm-2 py-4 px-1">
                        <h6 className="fw-semi-bold mb-2">{t('Religion')}:</h6>
                        <div className="d-flex flex-wrap list-group-items round-style">
                          <div className="list-item d-flex align-items-center justify-content-center py-2 px-3 fw-medium">
                            {api?.religion_title}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="w-[100%] h-[100vh] ms-[8rem] max-_991_:ms-0 bg-white fixed flex items-center justify-center top-0 left-0 right-0 bottom-0 z-[555]">
          <LodingLottie ClassCss={"w-[20%] max-_430_:w-[100%] max-_770_:w-[50%] max-_1030_:w-[40%] max-_1145_:w-[30%] max-_1200_:w-[30%] max-_1300_:w-[30%]"} />
        </div>
      )}

      {/* Block Section */}
      {isVisible && (
        <div onClick={toggleBottomSheet} id="BlockSection" className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
          <div onClick={(e) => e.stopPropagation()} className="w-[20%] max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
            <div className="flex flex-col justify-center items-center text-center">
              <img src={BlockIcon} alt="" className="w-[30%]" />
              <h4 className="m-0">{t('Blocking')} {api?.profile_name}</h4>
              <p className="mt-[20px] leading-[18px] text-[15px] pb-[15px]">
                {t('Please tell us why you are blocking')} <br /> {t("Acchcuu. Don't worry we won't tell them..")}
              </p>
              <div className="flex items-center border-t-[2px] pt-[10px] gap-[15px]">
                <div>
                  <div className="flex items-center gap-[15px]">
                    <img src={plus} alt="" />
                    <p className="text-start leading-[18px] font-[500]">
                      {t("They will not be able to find your profile and send you messages.")}
                    </p>
                  </div>
                  <div className="flex items-center gap-[10px] mt-[15px]">
                    <img src={Bell} alt="" />
                    <p className="text-start leading-[18px] font-[500]">
                      {t('They will not be notified if you block them.')}
                    </p>
                  </div>
                  <div className="flex items-center gap-[10px] mt-[15px]">
                    <img src={Setting} alt="" />
                    <p className="text-start leading-[18px] font-[500]">
                      {t('You can unblock them anytime in Settings.')}
                    </p>
                  </div>
                  <div className="flex justify-center gap-[20px] mt-[25px]">
                    <button onClick={toggleBottomSheet} id="BlockSection" className="text-[16px] text-[rgba(152,14,255,255)] h-[40px] max-h-[40px] border-[2px] border-[rgba(152,14,255,255)] rounded-full px-[25px]">
                      {t('Cancel')}
                    </button>
                    <button onClick={BlockHandler} className="text-[16px] text-white border-[2px] bg-[rgba(152,14,255,255)] rounded-full px-[25px] py-[8px]">
                      {t('Yes, Block')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Report Section */}
      {report && (
        <div onClick={() => ReportToggle('ReportSection')} className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
          <div onClick={(e) => e.stopPropagation()} className="w-[20%] max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
            <div className="flex flex-col justify-center items-center text-center">
              <div>
                <h3 className="m-0 font-[500]">{t('Reporting')} {api?.profile_name}</h3>
                <p className="leading-[18px] mt-[10px] font-[400] text-[16px]">{t("Pelease tell us why you are reporting")} <br /> {api?.profile_name}. {t("Don't worry we won't tell them")}</p>
                <h6 className=" text-start mt-[10px] font-[500] text-[18px]">{t("Why did you rport this user?")}</h6>
                <div className="ps-[10px]">
                  {ReportComment.map((item, index) => {
                    return (
                      <button key={index} onClick={() => { setDot(index); setComment(item); }} className="flex items-center gap-[35px] my-[15px]">
                        <div className="dot">
                          <span style={{ background: dot === index && "#980EFF" }} className="w-[100%] h-[100%] block rounded-full duration-[0.9s]"></span>
                        </div>
                        <h6 className="m-0 font-[400]">{item}</h6>
                      </button>
                    );
                  })}
                  <button onClick={() => SendReportHamdler(api.profile_id)} className="w-[100%] bg-[#980EFF] text-white rounded-full text-[18px] py-[8px] mt-[20px]">{t("Continue")}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Gift Section */}
      <GiftModal
        isVisible={isVisible2}
        onClose={() => setIsVisible2(false)}
        receiverId={api?.profile_id}
      />

      {/* Engagement Modal (Super Likes & Boosts) */}
      <EngagementModal
        isOpen={isEngagementOpen}
        onClose={() => setIsEngagementOpen(false)}
        baseUrl={basUrl}
        initialType={engagementInitialType}
      />

      {/* Fullscreen Image Preview Lightbox */}
      {previewOpen && imageData?.length > 0 && (
        <div
          className="fixed inset-0 z-[99999] bg-black/95 backdrop-blur-md flex flex-col justify-between p-4 sm:p-6 animate-fade-in select-none"
          onClick={() => setPreviewOpen(false)}
        >
          {/* Top Bar */}
          <div className="flex items-center justify-between w-full z-10" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center gap-3">
              <span className="text-white font-semibold text-base sm:text-lg bg-white/10 px-4 py-1.5 rounded-full backdrop-blur-md border border-white/20">
                {previewIndex + 1} / {imageData.length}
              </span>
              {api?.profile_name && (
                <span className="text-white/80 font-medium text-sm hidden sm:inline-block">
                  {api.profile_name}
                </span>
              )}
            </div>

            <button
              onClick={() => setPreviewOpen(false)}
              className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-all cursor-pointer border border-white/20 backdrop-blur-md"
              title={t("Close (Esc)")}
            >
              <RxCross2 className="text-2xl" />
            </button>
          </div>

          {/* Center Image Display */}
          <div className="relative flex-1 flex items-center justify-center my-4 overflow-hidden" onClick={(e) => e.stopPropagation()}>
            {imageData.length > 1 && (
              <button
                onClick={handlePrevImage}
                className="absolute left-2 sm:left-6 z-20 w-12 h-12 rounded-full bg-black/50 hover:bg-black/80 text-white flex items-center justify-center transition-all cursor-pointer border border-white/20 backdrop-blur-md shadow-xl"
                title={t("Previous Image")}
              >
                <MdChevronLeft className="text-3xl" />
              </button>
            )}

            <img
              src={`${imageBaseURL}${imageData[previewIndex]}`}
              alt="Preview"
              className="max-h-[75vh] max-w-[92vw] object-contain rounded-2xl shadow-2xl transition-transform duration-300 select-none"
            />

            {imageData.length > 1 && (
              <button
                onClick={handleNextImage}
                className="absolute right-2 sm:right-6 z-20 w-12 h-12 rounded-full bg-black/50 hover:bg-black/80 text-white flex items-center justify-center transition-all cursor-pointer border border-white/20 backdrop-blur-md shadow-xl"
                title={t("Next Image")}
              >
                <MdChevronRight className="text-3xl" />
              </button>
            )}
          </div>

          {/* Bottom Thumbnail Navigation Strip */}
          {imageData.length > 1 && (
            <div className="flex items-center justify-center gap-3 overflow-x-auto py-2 z-10 max-w-full" onClick={(e) => e.stopPropagation()}>
              {imageData.map((img, idx) => (
                <button
                  key={idx}
                  onClick={() => setPreviewIndex(idx)}
                  className={`w-14 h-14 sm:w-16 sm:h-16 rounded-xl overflow-hidden transition-all duration-200 cursor-pointer border-2 shrink-0 ${
                    previewIndex === idx
                      ? "border-purple-500 scale-105 shadow-lg shadow-purple-500/50 ring-2 ring-purple-400"
                      : "border-white/30 opacity-60 hover:opacity-100"
                  }`}
                >
                  <img src={`${imageBaseURL}${img}`} alt={`Thumb ${idx}`} className="w-full h-full object-cover" />
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Detail;
/* jshint ignore:end */
